import React from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { isFeatureAllowedByConfig } from '../../Product/product.utils'
import MultiPartyForm from './MultiPartyForm'
import { selectConfig } from 'store/tenant-config/selectors'
import { Feature } from 'store/products/types'
import useUpdateBreadcrumbs from 'pages/Product/hooks/useUpdateBreadcrumbs'

const MultiPartyFormPage = (): React.ReactElement => {
  const tenantConfig = useSelector(selectConfig)
  const { productKey = '' } = useParams()
  const navigate = useNavigate()

  useUpdateBreadcrumbs({ productKey, context: Feature.MULTI_PARTY })

  if (!isFeatureAllowedByConfig(tenantConfig, Feature.MULTI_PARTY)) navigate(`./../not-allowed`)

  return <MultiPartyForm />
}

export default MultiPartyFormPage
